/**
 * Format a numeric value with appropriate unit display
 * If a label is provided, show that instead of the numeric value
 */
export function formatValue(value: number, unit?: string, label?: string): string {
  // If we have a label (e.g., category like "UTG" or "fold"), show that
  if (label) {
    return label;
  }

  if (!unit || unit === '%') {
    return `${(value * 100).toFixed(0)}%`;
  }

  // For BB or other units, show decimals only if needed
  const formatted = value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);
  return `${formatted} ${unit}`;
}
